import React, {useEffect, useState} from 'react'
import {cx} from '@emotion/css'
import styled from '@emotion/styled'

const ComponentWrapper = styled.div<{
  duration: number
  isRendered: boolean
}>`
  will-change: opacity;
  transition: opacity ${({duration}) => duration}s ease-in-out;
  opacity: ${({isRendered}) => (isRendered ? 1 : 0)};
  left: 0;
  position: static;
  &.withPosition {
    &--isRendered {
      left: 0;
      position: static;
    }
    &--isNotRendered {
      position: absolute;
      left: -10000%;
    }
  }
`

interface Props {
  children: React.ReactNode
  skip?: boolean
  delay?: number
  duration?: number
  isVisible?: boolean
  ignorePosition?: boolean
  className?: string
}

const OpacityAnimation = ({
  children,
  skip = false,
  duration = 0.3,
  ignorePosition = false,
  isVisible = true,
  delay = 0,
  className
}: Props) => {
  const [isRendered, setIsRendered] = useState(!isVisible)

  useEffect(() => {
    const timeout = window.setTimeout(() => {
      setIsRendered(isVisible)
    }, delay)

    return () => {
      window.clearTimeout(timeout)
    }
  }, [isVisible, delay])

  if (skip) return <div>{children}</div>

  return (
    <ComponentWrapper
      isRendered={isRendered}
      duration={duration}
      className={cx(
        className,
        !ignorePosition &&
          `withPosition--${isRendered ? 'isRendered' : 'isNotRendered'}`
      )}
    >
      {children}
    </ComponentWrapper>
  )
}

export default React.memo(OpacityAnimation)
